import { render, staticRenderFns } from "./yx-link.vue?vue&type=template&id=3e60c9ca&scoped=true"
import script from "./yx-link.vue?vue&type=script&lang=js"
export * from "./yx-link.vue?vue&type=script&lang=js"
import style0 from "./yx-link.vue?vue&type=style&index=0&id=3e60c9ca&prod&lang=scss&scoped=true"
import style1 from "./yx-link.vue?vue&type=style&index=1&id=3e60c9ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e60c9ca",
  null
  
)

export default component.exports